import { createSelector } from "reselect";
import getProfessionSelector from "./getProfessionSelector";

export default createSelector(getProfessionSelector, (profession) => (profession.customDate ? new Date(profession.customDate) : null));
